
import { useEffect } from 'react';

interface AddToCartToastProps {
  isVisible: boolean;
  onClose: () => void;
  productName: string;
}

export default function AddToCartToast({ isVisible, onClose, productName }: AddToCartToastProps) {
  useEffect(() => {
    if (isVisible) {
      const timer = setTimeout(() => {
        onClose();
      }, 3000);
      return () => clearTimeout(timer);
    }
  }, [isVisible, onClose]);

  return (
    <div
      className={`fixed bottom-8 left-1/2 -translate-x-1/2 z-50 transition-all duration-300 ${
        isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4 pointer-events-none'
      }`}
    >
      <div className="flex items-center gap-3 bg-gray-900 text-white px-6 py-4 rounded-full shadow-lg">
        <div className="w-8 h-8 bg-amber-500 rounded-full flex items-center justify-center">
          <i className="ri-check-line text-white" />
        </div>
        <span className="font-medium whitespace-nowrap">{productName} 장바구니에 담았습니다</span>
      </div>
    </div>
  );
}
